<template lang="html">
  <div>    
    <setup-branch-profile-edit-form  
      v-show="showProfile" 
      :branch-uid="selectedBranchUid"
      @updated="getBranchList()"
    >
      <template v-slot:breadcrumb>
        <v-breadcrumbs 
          :items="items" 
          divider="/"
        >
          <template v-slot:item="props">
            <v-breadcrumbs-item :class="[props.item.disabled && 'disabled']">
              <a 
                :class="[props.item.disabled && 'disabled']"
                @click="closeBranchProfile()"
              >{{ props.item.text }}</a>
            </v-breadcrumbs-item>
          </template>        
        </v-breadcrumbs>
      </template>
    </setup-branch-profile-edit-form>
    <setup-branch-overview-sidebar-filter 
      ref="filter"
      @proficient-skill-filter="updateProficientSkillFilter"
      @deficient-skill-filter="updateDeficientSkillFilter"
    />

    <v-container 
      v-show="!showProfile" 
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-card class="elevation-5">
            <v-toolbar
              flat
              color="white"
            >
              <v-text-field
                v-model="searchInput"
                append-icon="search"
                placeholder="Search by Branch Name, State or City"
                single-line
                hide-details
              />

              <v-checkbox
                v-if="!$vuetify.breakpoint.smAndDown"
                v-model="hideOmBic"
                label="Hide OM/BIC"
                class="mt-6 ml-2"
                required
              />
              <v-spacer />

              <v-chip
                v-for="skill in proficientSkillFilterList"
                :key="skill.id"
                close
                color="green"
                text-color="white"
                @click:close="skill.rating=1;removeProficientSkillFilter(skill)"
              >
                {{ skill.name }}: Level {{ skill.rating }}
              </v-chip>

              <v-chip
                v-for="skill in deficientSkillFilterList"
                :key="skill.id"
                close
                color="red"
                text-color="white"
                @click:close="skill.rating=1;removeDeficientSkillFilter(skill)"
              >
                {{ skill.name }}
              </v-chip>

              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn   
                    text
                    icon           
                    color="primary"
                    v-on="on"
                    @click.stop="$refs.filter.drawer = true"
                  >
                    <v-icon 
                      v-if="proficientSkillFilterList.length>0 || 
                        deficientSkillFilterList.length>0" 
                      medium
                    >
                      filter_list_alt
                    </v-icon>

                    <v-icon 
                      v-else
                      medium
                    >
                      filter_list
                    </v-icon>
                  </v-btn> 
                </template>
                <span>Advanced Skill filter</span>
              </v-tooltip>

              <setup-branch-dialog-create
                v-if="this.$hasPermissionTo(['create branches'])"
                @updated="getBranchList()"
              />

              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-avatar 
                    class="cursor-pointer"
                    v-on="on"   
                    @click="getBranchList"             
                  >
                    <v-icon medium>
                      mdi-refresh
                    </v-icon>
                  </v-avatar>
                </template>
                <span>Reload</span>
              </v-tooltip>
            </v-toolbar>
            <v-data-table
              :sort-by.sync="sortBy"
              :items-per-page="itemsPerPage"
              :loading="tableLoading"
              :headers="headers"
              :items="filteredBranches"
              item-key="branch_uid"
            > 
              <v-progress-linear
                v-slot:progress
                color="blue"
                indeterminate
              />

              <template v-slot:item="props">
                <tr>
                  <td>
                    <a 
                      class="font-weight-bold light-blue--text  text--darken-3" 
                      @click="showBranchProfile(props.item.branch_uid)"
                    >
                      {{ props.item.branch_name }}
                    </a>
                  </td>
                  <td v-if="!hideOmBic">
                    {{ props.item.operation_manager ? props.item.operation_manager.name : '' }}
                  </td>
                  <td v-if="!hideOmBic">
                    {{ props.item.user_in_charge ? props.item.user_in_charge.name : '' }}
                  </td>

                  <td v-if="!$vuetify.breakpoint.smAndDown">
                    <!-- data-simplebar / -->
                    <v-row 
                      v-if="props.item.skills.length>0" 
                    >
                      <v-col 
                        cols="1" 
                      >
                        <v-btn 
                          color="primary" 
                          text 
                          icon
                          @click="toLeft(skillListNamePrefix+props.index)"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col>
                        <div 
                          :id="skillListNamePrefix+props.index"
                          :class="hideOmBic=== false? 'horizontal-scroll-xl': 'horizontal-scroll'"
                        >  
                          <v-row class="flex-nowrap">
                            <span 
                              v-for="(skill,key) in props.item.skills"
                              :key="key"
                              class="px-4"
                            >

                              <v-menu
                                :close-on-content-click="false"
                                :nudge-width="200"
                                open-on-hover
                                offset-x
                              >
                                <template v-slot:activator="{ on }">
                                  <v-badge 
                                    class="pl-2"
                                    overlap
                                    bottom 
                                  >
                                    <template v-slot:badge>
                                      <span 
                                        v-on="on"
                                      >{{ skill.count }}</span>
                                    </template>

                                    <setup-branch-dialog-skill-movement-overview 
                                      :branch-list="branchList"
                                      :selected-skill="skill.skill_id"
                                      :branch="props.item"
                                    >
                                      <template v-slot:activator="{on}">
                                        <v-avatar
                                          class="cursor-pointer"
                                          size="30"
                                          tile
                                          v-on="on"
                                        >
                                          <img
                                            :src="skill.image_url"
                                            alt="skill logo"
                                          >
                                        </v-avatar>
                                      </template>
                                    </setup-branch-dialog-skill-movement-overview>

                                  </v-badge>

                                  <v-rating 
                                    :value="skill.highest_available_employee_level"
                                    :length="skill.highest_lv"
                                    readonly
                                    class="text-center"
                                    background-color="indigo lighten-3"
                                    color="indigo"
                                    size="10"
                                  />

                                </template>

                                <v-card>
                                  <v-list>
                                    <v-list-item>
                                      <v-list-item-avatar>
                                        <v-avatar
                                          size="40"
                                          tile 
                                        >
                                          <img
                                            :src="skill.image_url"
                                            alt="skill logo"
                                          >
                                        </v-avatar>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title>{{ skill.name }}</v-list-item-title>
                                      </v-list-item-content>

                                    </v-list-item>
                                  </v-list>

                                  <v-divider />
                                  <v-list>
                                    <template 
                                      v-for="(item,index) in reverseLevels(skill.levels)"
                                    >
                                      <v-list-item :key="index">
                                        <v-list-item-content class="py-0"> 
                                          <v-list-item-title> 
                                            <v-row>
                                              <v-col class="pr-1 py-0">
                                                <v-rating 
                                                  :size="20"
                                                  :value="5-index"
                                                  readonly
                                                /> 
                                              </v-col>
                                              <v-col
                                                md="3"
                                                class="pt-0"
                                              >
                                                ({{ item.length }})
                                              </v-col>
                                            </v-row>
                                              
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-list>
 
                                </v-card>
                              </v-menu>
                              
                            </span>
                          </v-row>
                        </div>
                      </v-col>

                      <v-col>
                        <v-btn 
                          color="primary" 
                          text
                          icon
                          @click="toRight(skillListNamePrefix+props.index)"
                        >
                          <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card> 
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      SetupBranchDialogSkillMovementOverview: () => import('@/components/setup/branch/DialogSkillMovementOverview'),
      SetupBranchOverviewSidebarFilter: () => import('@/components/setup/branch/OverviewSidebarFilter'),
      SetupBranchProfileEditForm: () => import('@/components/setup/branch/ProfileEditForm'),
      SetupBranchDialogCreate: () => import('@/components/setup/branch/DialogCreate'),
    },
    data: () => ({
      skillListNamePrefix: 'skill-list',
      sortBy: 'branch_name',
      itemsPerPage: 10,
      tableLoading: false,
      branchList: [],
      selectedBranchUid: null,
      showProfile: false,
      items: [
        {
          text: 'Branch',
          disabled: false,
          closeProfile: true,
        },
        {
          text: 'Profile',
          disabled: true,
        
        },
      ],
      searchInput: '',
      proficientSkillFilterList: [],
      deficientSkillFilterList: [],
      proficientSkillLevelFilterValue: 0,
      hideOmBic: false,
    }),
    computed: {
      headers: function () {
        if (this.hideOmBic === true) {
          return [
            {
              text: 'Branch Name',
              align: 'left',
              value: 'branch_name',
              width: '25%',
            },
            {
              text: 'Skills',
              align: 'left',
              sortable: false,
            },

          ]
        }
        return [
          {
            text: 'Branch Name',
            align: 'left',
            value: 'branch_name',
            width: '25%',
          },
          {
            text: 'OM',
            align: 'left',
            value: 'operation_manager.name',
            width: '20%',
          },
          {
            text: 'BIC',
            align: 'left',
            value: 'user_in_charge.name',
            width: '20%',
          },
          {
            text: 'Skills',
            align: 'left',
            sortable: false,
          },

        ]
      },
      filteredBranches: function () {
        let _this = this
        // return 
        let primaryFilterBranches = this.branchList.filter(function (branch) {
          return branch.branch_name.toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 ||
            branch.branch_city.toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 ||
            ((branch.state || {}).state_name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1         
        })
      
        let proficientBranches = this.filterBranchWithProficientSkills(primaryFilterBranches)
        let deficientBranches = this.filterBranchWithDeficientSkills(proficientBranches)

        return deficientBranches
      },
    },
    mounted () {
      this.getBranchList()
      if (this.$vuetify.breakpoint.smAndDown) {
        this.hideOmBic = true
      }
    },  
    methods: {
      reverseLevels: (levels) => {
        return levels.slice().reverse()
      },
      filterBranchWithProficientSkills (branchList) {
        return branchList.filter((branch) => {
          let hasAllSkills = true

          if (branch.skills.length === 0) {
            if (this.proficientSkillFilterList.length === 0) {
              return true
            } else {
              return false
            }
          }

          this.proficientSkillFilterList.forEach((filteredSkill) => {
            let found = branch.skills.findIndex((skill) => {
              return skill.skill_id === filteredSkill.id && 
                filteredSkill.rating <= skill.highest_available_employee_level
            })

            if (found === -1) {
              hasAllSkills = false
            }
          })
        
          return hasAllSkills
        })
      },
      filterBranchWithDeficientSkills (branchList) {
        return branchList.filter((branch) => {
          let doesntHaveAllSkills = true

          if (branch.skills.length === 0) {
            return true
          }

          this.deficientSkillFilterList.forEach((filteredSkill) => {
            let found = branch.skills.findIndex((skill) => {
              return skill.skill_id === filteredSkill.id
            })

            if (found > 0) {
              doesntHaveAllSkills = false
            }
          })
          return doesntHaveAllSkills
        })
      },
      toRight (id) {
        document.querySelector('#' + id).scrollLeft += 50
      },
      toLeft (id) {
        document.querySelector('#' + id).scrollLeft -= 50
      },    
      closeBranchProfile () {
        this.showProfile = false
      },
      showBranchProfile (branchUid) {
        this.selectedBranchUid = branchUid
        this.showProfile = true
      },
      summarizeSkills (users) {
        let branchSkills = []

        users.forEach((user) => {
          if (((user.person || {}).employee || {}).skills !== undefined) {
            if (user.person.employee.skills.length > 0) {
              let skills = user.person.employee.skills
            
              skills.forEach((skill) => {
                let activeSkill = branchSkills.find((branchSkill) => branchSkill.skill_id === skill.skill_id)
              
                if (activeSkill) {
                  activeSkill.count += 1
                  activeSkill.levels[skill.skill_level.level - 1].push(user)

                  if (activeSkill.highest_available_employee_level < skill.skill_level.level) {
                    activeSkill.highest_available_employee_level = skill.skill_level.level
                  }
                } else {
                  let levels = [[], [], [], [], []]

                  levels[skill.skill_level.level - 1].push(user)
                
                  branchSkills.push({
                    skill_id: skill.skill_id,
                    highest_available_employee_level: skill.skill_level.level,
                    count: 1,
                    name: skill.skill.name,
                    image_url: skill.skill.image_url,
                    levels: levels,
                    active: false, // for menu use
                  })
                }
              })
            }
          }
        })
      
        return branchSkills.sort((a, b) => {
          return a.highest_available_employee_level > b.highest_available_employee_level ? -1 : 1
        })
      },
      getBranchList () {
        this.tableLoading = true
        this.$api.branches().overview()
          .then((branches) => {
            branches.data.forEach((branch) => {
              branch.skills = this.summarizeSkills(branch.active_users)
            })
          
            this.branchList = branches.data
          })
          .then(() => {
            this.tableLoading = false
          })
      },
      updateProficientSkillFilter (val) {
        this.proficientSkillFilterList = val
      },
      updateDeficientSkillFilter (val) {
        this.deficientSkillFilterList = val
      },
      removeProficientSkillFilter (item) {
        let index = this.proficientSkillFilterList.findIndex(selected => selected.id === item.id)
        if (index >= 0) this.proficientSkillFilterList.splice(index, 1)
      },
      removeDeficientSkillFilter (item) {
        let index = this.deficientSkillFilterList.findIndex(selected => selected.id === item.id)
        if (index >= 0) this.deficientSkillFilterList.splice(index, 1)
      },
    },
  }
</script>

<style lang="css" scoped>
  .disabled {
    color: grey;
    pointer-events: none;
  }
  
</style>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-rating .v-icon{
    padding:0px;
  }

  ::v-deep .v-rating {
    width:50px;
  }
  
  v-table__overflow{
    overflow-x:hidden;
  }

  .horizontal-scroll{
    overflow-x:hidden; 
    overflow-y:hidden; 
    width:50vw;
  }

  .horizontal-scroll-xl{
    overflow-x:hidden; 
    overflow-y:hidden; 
    width:20vw;
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>
